import { SidePanel } from '@wix/design-system';
import React, { useEffect } from 'react';
import { CustomColumnsState } from '../../state';
import { FiltersMap, withoutDefaults } from '@wix/bex-core';
import { observer } from 'mobx-react-lite';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { ColumnsList } from './ColumnsList';
import { useRafRender } from '../../hooks/useRafRender';
import { cairoFiltersPanelUsed } from '@wix/bex-core/bi';
import { ScrollableContent } from '../ScrollableContent';

export interface CustomColumnsPanelProps<T, F extends FiltersMap> {
  state: CustomColumnsState<T, F>;
}

export function _CustomColumnsPanel<T, F extends FiltersMap>({
  state,
}: CustomColumnsPanelProps<T, F>) {
  const container = useWixPatternsContainer();
  const { translate: t } = container;

  const entered = useRafRender();

  const { table, dragAndDrop } = state;
  const { sidePanel, collectionDataExtension } = table;

  useEffect(() => state.init(), []);

  if (!entered) {
    return null;
  }

  return (
    <SidePanel
      dataHook="custom-columns-panel"
      width="100%"
      onCloseButtonClick={() => {
        table.reportBi(
          withoutDefaults(cairoFiltersPanelUsed)({
            isOpened: false,
            feature: 'Custom Columns',
            origin: 'X Button',
          }),
        );
        sidePanel.close();
      }}
    >
      <SidePanel.Header
        title={t('cairo.table.custom-columns.title')}
        subtitle={
          dragAndDrop
            ? t('cairo.table.custom-columns.dragAndDrop.subtitle')
            : t('cairo.table.custom-columns.subtitle')
        }
      />
      <ScrollableContent
        overflowY
        dataHook="custom-columns-panel-scroll-container"
        ref={(e) => {
          if (state.dragAndDrop) {
            state.dragAndDrop.listRect.element = e;
          }
        }}
      >
        <ColumnsList state={state} />
      </ScrollableContent>
      {collectionDataExtension?.DataExtension
        ?.CustomColumnsAddCustomFieldCTAButton && (
        <collectionDataExtension.DataExtension.CustomColumnsAddCustomFieldCTAButton />
      )}
    </SidePanel>
  );
}

export const CustomColumnsPanel = observer(_CustomColumnsPanel);
